// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import resetRem from '@/common/scripts/resetRem.js';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from './i18n/i18n';
import 'font-awesome/css/font-awesome.css';
import VueMeta from 'vue-meta';
import Vant from 'vant';
import 'vant/lib/index.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import {  instance } from './views/yf/request.js'; 

Vue.use(ElementUI);
axios.defaults.baseURL = '/api'; // 设置 API 基础 URL
Vue.prototype.$http = instance;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.use(Vant)
Vue.use(resetRem);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta);
AOS.init();

// 百度统计
router.afterEach((to, from, next) => {
  setTimeout(() => {
    (function () {
      // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?e0cc108252c6634eeca0926d5b4e89ac';
      hm.id = 'baidu_tj';
      hm.language = 'JavaScript';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.appendChild(hm, s);
    })();
  }, 0);
});

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App),
  // 预渲染
  mounted () {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js